module.exports = __webpack_public_path__ + "static/media/azurecloudlogo.4a116f42.png";